import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { Model } from "../../types/generated/api/Model"
import type { ModelListCreate } from "../../types/generated/api/ModelListCreate"

export const ModelSlice = createSlice({
  name: "models",
  initialState: {
    currentModel: undefined as Model | ModelListCreate | undefined,
  },
  reducers: {
    setCurrentModel: (state, action: PayloadAction<Model | ModelListCreate | undefined>) => {
      state.currentModel = action.payload
    },
  },
})

export const { setCurrentModel } = ModelSlice.actions
